import { createEvent } from "@cobuildlab/react-simple-state";
import { GoldSubsidy } from "../../shared/types";

export const OnFetchGoldSubsidies = createEvent<GoldSubsidy[]>();
export const OnFetchGoldSubsidiesError = createEvent();

export const OnFetchCryptoGoldSubsidies = createEvent<GoldSubsidy[]>();
export const OnFetchCryptoGoldSubsidiesError = createEvent();
